import {Component, Input, OnInit} from '@angular/core';
import {ModalController} from "@ionic/angular";

@Component({
  selector: 'app-select-date-modal',
  templateUrl: './select-date-modal.component.html',
  styleUrls: ['./select-date-modal.component.scss'],
})
export class SelectDateModalComponent implements OnInit {
  @Input() title: string;
  @Input() innerTitle: string;

  constructor(private modalController: ModalController) { }

  ngOnInit() {}

  onClose() {
    this.modalController.dismiss();
  }

  onDateSelected(selectedDate: string) {
    this.modalController.dismiss(selectedDate, 'date-selected');
  }
}
